export const arrayAlphabetic = (arrayOfObjects) => {
  return arrayOfObjects.sort((a, b) => {
    let textA = a.name.toUpperCase()
    let textB = b.name.toUpperCase()
    return textA < textB ? -1 : textA > textB ? 1 : 0
  })
}
